import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './profile.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { Icon } from '@iconify/react'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { login } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import { fileUpload } from '../../utils/request'
import { myProfile, myProfileUpdate } from '../../api/package';
// -------------------------------------------------

const Profile = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const notify = (message) => toast(message)
  const token = localStorage.getItem('token')
  const [profile, setProfile] = useState('')

  const getProfileData = async () => {
    const resp = await myProfile()
    setProfile(resp.data)
    setValue('name', resp.data.name)
    setValue('email', resp.data.email)
    setValue('mobile', resp.data.mobile)
  }

  useEffect(() => {
    if (token) {
      getProfileData()
    }

  }, [])


  const LoginSchema = Yup.object().shape({
    mobile: Yup.string().matches(/^\d{10}$/, 'must be 10 numbers').required('Mobile is Required'),
    email: Yup.string().email().matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      , 'must be valid email').required('Email is required'),
    name: Yup.string().required('Name is required')
  });

  const defaultValues = {
    mobile: '',
    email: '',
    name: ''
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    setValue,
    formState: { isSubmitting, errors },
  } = methods;
  const values = watch()
  console.log(errors)
  const onSubmit = async () => {

    if (values.email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      , 'must be valid email') || values.mobile.toString().length === 10 || values?.name !== '') {
      try {
        const response = await myProfileUpdate(values)
        if (response.code === 202) {
          notify(response.message)
          navigate('/')
        } else {

          notify(response.message)
        }
      } catch (error) {
        notify(error.message)
      }
    } else {
      notify('Please check your form')
    }


    setShowLoader(false)
  };

  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-5'>
              <div class="card border">
                <div class="card-header border-bottom">
                  <h4 class="card-header-title">Personal Information</h4>
                </div>
                <div class="card-body row">
                  {/* <div class="col-md-5">
                    <div className="profileImgCol">
                      <img
                        src={values?.image || '/images/avatar.jpeg'}
                        alt="Profile"
                      />
                      <div className="sub-group">
                        <label for="uploadImage" class="btn btn-anchor">
                          <Icon icon="majesticons:camera" />
                        </label>
                        <input
                          id="uploadImage"
                          type="file"
                          onChange={async (e) => {
                            const resp = await fileUpload(
                              e.target.files[0],
                              '/file',
                            )
                            const url = JSON.parse(resp) || '[]'
                            setValue('image', url?.fileUrl)
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                  <div class="col-md-12">
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                      <Stack sx={{ py: 2 }}>
                        <RHFTextField
                          InputLabelProps={{ shrink: true }}
                          name="name"
                          label="Name"
                          size="small"
                        />
                      </Stack>
                      <Stack sx={{ py: 1 }}>
                        <RHFTextField InputLabelProps={{ shrink: true }} size="small" type='number' name="mobile" label="Mobile" />
                      </Stack>
                      <Stack sx={{ py: 2 }}>
                        <RHFTextField
                          InputLabelProps={{ shrink: true }}
                          name="email"
                          label="Email"
                          size="small"
                          type='email'
                        />
                      </Stack>
                      <Stack sx={{ py: 1 }}>
                        <button fullWidth size="large" className='signBtn' onSubmit={onSubmit}>
                          Save Changes
                        </button>
                      </Stack>
                    </FormProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Profile
